// 1029：所有 API 都走同一個網域 https://eap.taiwanxai.com.tw/api（相對路徑）
// - 用 https://eap.taiwanxai.com.tw 開網頁：nginx 把 /api 轉到後端 192.168.41.40:8516
// - 用 http://192.168.41.20:3005 開網頁：rsbuild 開發伺服器把 /api 轉到後端（設定在 rsbuild.config.mjs）
export const API_BASE_URL = '/api';
